"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var types = _interopRequireWildcard(require("./types"));
var _array = require("../../utils/array");
var _types2 = require("../session/types");
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  itemsByFeed: {},
  filesByFeed: {},
  progressionByFeed: {},
  isSending: {},
  isFetching: {},
  isEndReached: {},
  firstItemByFeed: {},
  replayableFailureItems: [],
  _lastFileFeedItems: []
};
var feedItemReducer = function feedItemReducer() {
  var _state$progressionByF, _state$progressionByF2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.ADD_REPLAYABLE_FEED_ITEM_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        replayableFailureItems: (0, _uniqBy.default)([...(state.replayableFailureItems || []), action.feedItem], '_feedItem')
      });
    case types.SET_FIRST_FEED_ITEM:
      return _objectSpread(_objectSpread({}, state), {}, {
        firstItemByFeed: _objectSpread(_objectSpread({}, state.firstItemByFeed || {}), {}, {
          [action._feed]: action._feedItem
        })
      });
    case types.REMOVE_REPLAYABLE_FEED_ITEM_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        replayableFailureItems: state.replayableFailureItems.filter(_ref => {
          var {
            _feedItem
          } = _ref;
          return _feedItem !== action._feedItem;
        })
      });
    case types.WS_DELETE_FEED_ITEM:
      {
        var _state$itemsByFeed$_f, _state$filesByFeed$_f;
        var {
          _feed,
          id
        } = action.payload;
        var excludeFeedItem = _feedItem => _feedItem !== id;
        return _objectSpread(_objectSpread({}, state), {}, {
          itemsByFeed: _objectSpread(_objectSpread({}, state.itemsByFeed), {}, {
            [_feed]: (_state$itemsByFeed$_f = state.itemsByFeed[_feed]) === null || _state$itemsByFeed$_f === void 0 ? void 0 : _state$itemsByFeed$_f.filter(excludeFeedItem)
          }),
          filesByFeed: _objectSpread(_objectSpread({}, state.filesByFeed), {}, {
            [_feed]: (_state$filesByFeed$_f = state.filesByFeed[_feed]) === null || _state$filesByFeed$_f === void 0 ? void 0 : _state$filesByFeed$_f.filter(excludeFeedItem)
          })
        });
      }
    case types.REMOVE_FEED_ITEMS:
    case types.REQUEST_DELETE_LOCAL_FEED_ITEMS:
      {
        var matchFeedItems = _feedItem => !action._feedItems.includes(_feedItem);
        (0, _forEach.default)(state.itemsByFeed || {}, (feedItems, _feed) => {
          state.itemsByFeed[_feed] = feedItems === null || feedItems === void 0 ? void 0 : feedItems.filter(matchFeedItems);
        });
        (0, _forEach.default)(state.filesByFeed || {}, (feedItems, _feed) => {
          state.filesByFeed[_feed] = feedItems === null || feedItems === void 0 ? void 0 : feedItems.filter(matchFeedItems);
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          itemsByFeed: _objectSpread({}, state.itemsByFeed),
          filesByFeed: _objectSpread({}, state.filesByFeed)
        });
      }
    case types.ADD_FEED_FILES:
      return _objectSpread(_objectSpread({}, state), {}, {
        filesByFeed: _objectSpread(_objectSpread({}, state.filesByFeed || {}), {}, {
          [action._feed]: (0, _array.flatUniqConcat)(action._feedItems, state.filesByFeed[action._feed] || [])
        })
      });
    case types.RESET_FEED_ITEM_UPLOAD_PROGRESSION:
      return _objectSpread(_objectSpread({}, state), {}, {
        progressionByFeed: _objectSpread(_objectSpread({}, state.progressionByFeed || {}), {}, {
          [action._feed]: _objectSpread(_objectSpread({}, ((_state$progressionByF = state.progressionByFeed) === null || _state$progressionByF === void 0 ? void 0 : _state$progressionByF[action._feed]) || {}), {}, {
            [action._feedItem]: {
              loaded: undefined,
              total: undefined
            }
          })
        })
      });
    case types.SET_FEED_ITEM_UPLOAD_PROGRESSION:
      return _objectSpread(_objectSpread({}, state), {}, {
        progressionByFeed: _objectSpread(_objectSpread({}, state.progressionByFeed || {}), {}, {
          [action._feed]: _objectSpread(_objectSpread({}, ((_state$progressionByF2 = state.progressionByFeed) === null || _state$progressionByF2 === void 0 ? void 0 : _state$progressionByF2[action._feed]) || {}), {}, {
            [action._feedItem]: {
              loaded: action.loaded,
              total: action.total
            }
          })
        })
      });
    case types.ADD_FEED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        itemsByFeed: _objectSpread(_objectSpread({}, state.itemsByFeed || {}), {}, {
          [action._feed]: (0, _array.flatUniqConcat)(action._feedItems, state.itemsByFeed[action._feed] || [])
        }),
        replayableFailureItems: state.replayableFailureItems.filter(item => !action._feedItems.includes(item._feedItem))
      });
    case types.SET_FEED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        itemsByFeed: _objectSpread(_objectSpread({}, state.itemsByFeed || {}), {}, {
          [action._feed]: (0, _array.flatUniqConcat)(action._feedItems, [])
        }),
        replayableFailureItems: (state.replayableFailureItems || []).filter(item => !action._feedItems.includes(item._feedItem))
      });
    case types.SET_FEED_FILES:
      return _objectSpread(_objectSpread({}, state), {}, {
        filesByFeed: _objectSpread(_objectSpread({}, state.filesByFeed || {}), {}, {
          [action._feed]: (0, _array.flatUniqConcat)(action._feedItems, [])
        })
      });
    case types.SET_IS_FETCHING_FEED_ITEM:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: _objectSpread(_objectSpread({}, state.isFetching || {}), {}, {
          [action._feed]: action.isFetching
        })
      });
    case types.SET_FEED_ITEM_IS_END_REACHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isEndReached: _objectSpread(_objectSpread({}, state.isEndReached || {}), {}, {
          [action._feed]: action.isEndReached
        })
      });
    case types.SET_LAST_FILE_FEED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        _lastFileFeedItems: action._items
      });
    case _types2.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    default:
      return state;
  }
};
var _default = exports.default = feedItemReducer;
module.exports = exports.default;